// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3J5bs","info":"Note_info__9A9dH","note":"Note_note__QGk6s","actions":"Note_actions__2DrFP"};